<template>
  <div class="iftttNotice_options_item iftttNotice_options_time">
    <ifttt-option-left :num="2" :label="$t('ifttt.effectiveCount')" />
    <el-radio-group v-model="seqCycleRadio" style="height: 40px!important;">
      <el-radio :label="0">
        {{ $t('ifttt.repeatLoop') }}
      </el-radio>
      <el-radio :label="1">
        {{ $t('iftttset.executeOnlyOnce') }}
      </el-radio>
      <el-radio :label="2">
        <span style="margin-right: 10px;">{{ $t('ifttt.customLoopCount') }}</span>
        <el-input-number
          v-model="seqCycleNum"
          :min="1"
          :max="10"
          :label="$t('ifttt.times')"
        />
        <span style="margin-left: 10px;">{{ $t('ifttt.times') }}</span>
      </el-radio>
    </el-radio-group>
  </div>
</template>

<script>
import { alertsuccess } from '@/assets/js/common.js'
import IftttOptionLeft from './IftttOptionLeft'

export default {
  components: {
    IftttOptionLeft,
  },
  props: {
    initData: {
      type: Number,
      default: 1
    },
  },
  data () {
    return {
      seqCycleRadio: 1,
      seqCycleNum: 1,
    }
  },
  watch: {
    initData: {
      handler (val) {
        debugger
        if(val === 0 || val === 1) {
          this.seqCycleRadio = val
        }else{
          this.seqCycleRadio = 2
          this.seqCycleNum = val
        }
      },
      immediate: true
    }
  },
  methods: {
    getRadioValue () {
      if (this.seqCycleRadio === 2) {
        return this.seqCycleNum
      }
      return this.seqCycleRadio
    },
    getDefaultTimePeriod () {
      return {
        effectivedate: '2019-01-01,2088-12-31',
        holiday: false,
        time: '00:00',
        weeks: 'Mon Tues Wed Thur Fri Sat Sun',
        zone: 0,
        flag: 1,
        month: 0,
        date: 0,
        startYear: 0,
        startMonth: 0,
        startDay: 0,
        endYear: 0,
        endMonth: 0,
        endDay: 0
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.iftttNotice_option_left {
  width: 150px;
}
.iftttNotice_options_time {
  display: flex;
  align-items: center;
  
  .el-radio-group {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    
    ::v-deep .el-radio {
      display: flex;
      align-items: center;
      margin-right: 30px;
      line-height: 1;
      
      .el-radio__input {
        display: flex;
        align-items: center;
      }
      
      .el-radio__label {
        display: flex;
        align-items: center;
        padding-left: 8px;
      }
    }
  }
}
</style>
